// Small date helpers for reminders + scheduled messages (local time — the team is on SAST).
const at = (d, h, m = 0) => { const x = new Date(d); x.setHours(h, m, 0, 0); return x; };

export const inOneHour = () => new Date(Date.now() + 60 * 60 * 1000);
export const tomorrowAt = (h) => { const d = new Date(); d.setDate(d.getDate() + 1); return at(d, h); };
/** Next Monday at h:00 (a week ahead when today is Monday). */
export const nextMondayAt = (h) => { const d = new Date(); const add = ((8 - d.getDay()) % 7) || 7; d.setDate(d.getDate() + add); return at(d, h); };

/** "Tomorrow 09:00" / "Mon 13 Oct 09:00" / "Today 15:30" */
export function whenLabel(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const t = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  const today = new Date(); const tmr = new Date(); tmr.setDate(today.getDate() + 1);
  if (d.toDateString() === today.toDateString()) return `Today ${t}`;
  if (d.toDateString() === tmr.toDateString()) return `Tomorrow ${t}`;
  return `${d.toLocaleDateString([], { weekday: "short", day: "numeric", month: "short" })} ${t}`;
}

/** Value for <input type="datetime-local"> from a Date. */
export const toLocalInput = (d) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};
